import { formatThousands, hexToRGB } from './format.js';
import { loadChart } from './chart-runtime.js';
import { chartTheme as T, tokenColor } from './theme.js';


// A chart built with Chart.js 3
// https://www.chartjs.org/
const line = () => ({
    id: '',
    options: {},
    chart: null,
    values: [],
    labels: [],
    growing: false,
    format: "thousands",
    color: null,
    type: '',
    async createChart() {
        const Chart = await loadChart();
        const ctx = document.getElementById(this.id);
        if (!ctx) return;
        if (this.chart) {
            this.chart.destroy()
        }

        let defaultOptions = {
            layout: {
                padding: {
                    top: 12,
                    bottom: 16,
                    left: 2,
                    right: 2,
                },
            },
            scales: {
                y: {
                    beginAtZero: true,
                    display: false,
                    grid: {
                        display: false,
                        drawBorder: false,
                        drawTicks: false,
                    },
                },
                x: {
                    // hide
                    display: false,
                }
                // x: {
                //     type: 'time',
                //     time: {
                //         parser: 'yyyy-MM-dd',
                //         unit: 'month',
                //         displayFormats: {
                //             month: 'MMM yy',
                //         },
                //     },
                //     grid: {
                //         display: false,
                //         drawBorder: false,
                //     },
                //     ticks: {
                //         autoSkipPadding: 48,
                //         maxRotation: 0,
                //     },
                // },
            },
            plugins: {
                tooltip: {},
                legend: {
                    display: false,
                },
            },
            interaction: {
                intersect: false,
                mode: 'nearest',
            },
            maintainAspectRatio: false,
        }

        if (this.format === "thousands") {
            const showDate = this.type === 'ticker';
            defaultOptions.plugins.tooltip.callbacks = {
                title: () => false,
                label: (context) => {
                    const val = formatThousands(context.parsed.y);
                    if (!showDate) return val;
                    const raw = context.label;
                    if (!raw) return val;
                    try {
                        const d = new Date(raw);
                        if (Number.isNaN(d.getTime())) return val;
                        const dateStr = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
                        return `${dateStr} — ${val}`;
                    } catch {
                        return val;
                    }
                },
            }
        }
        else if(this.format === "percentage")
        {
            defaultOptions.plugins.tooltip.callbacks = {
                title: () => false,
                label: (context) => context.parsed.y + "%",
            }
        }

        const { fitToData, ...options } = this.options;

        let mergedOptions = {
            ...defaultOptions,
            ...options,
        }

        const maxYValue = Math.max(...this.values);

        if (fitToData) {
            // Fit the axis to the data, but never tighter than 1% of the
            // value, so tiny drifts don't fill the chart.
            const minYValue = Math.min(...this.values);
            const span = Math.max(maxYValue - minYValue, Math.abs(maxYValue) * 0.01) || 1;
            const middle = (maxYValue + minYValue) / 2;
            mergedOptions.scales.y.beginAtZero = false;
            mergedOptions.scales.y.min = middle - span * 0.6;
            mergedOptions.scales.y.max = middle + span * 0.6;
        } else {
            mergedOptions.scales.y.max = maxYValue + (0.1 * maxYValue);
        }

        let backgroundColor, borderColor, pointBackgroundColor
        if (this.color) {
            backgroundColor = `rgba(${hexToRGB(this.color)}, 0.08)`
            borderColor = this.color
            pointBackgroundColor = this.color
        } else if (this.growing) {
            backgroundColor = tokenColor('chart-positive', 0.08)
            borderColor = T.positive
            pointBackgroundColor = T.positive
        } else {
            backgroundColor = tokenColor('chart-negative', 0.08)
            borderColor = T.negative
            pointBackgroundColor = T.negative
        }

        return new Chart(ctx, {
            type: 'line',
            data: {
                labels: this.labels,
                datasets: [
                    {
                        label: '',
                        data: this.values,
                        borderColor: borderColor,
                        fill: true,
                        backgroundColor: backgroundColor,
                        borderWidth: 2,
                        tension: 0.4,
                        pointRadius: 0,
                        pointHoverRadius: 3,
                        pointBackgroundColor: pointBackgroundColor,
                        clip: 20,
                    },
                ],
            },
            options: mergedOptions,
        });
    },
    async initChart(id, options = {}, format = 'thousands', growing, color = null, type = '') {
        this.id = id
        this.options = options
        this.format = format
        this.growing = growing
        this.color = color
        this.type = type
        this.chart = await this.createChart()
    },
})

export default line;
